import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../helpers/EventEmitter';
import { isNotLoginOrExpired } from '../../helpers/Common';

class DropDownItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowActionEditDelete: false,
      isShowConfirmEdit: false,
      isShowConfirmDelete: false,
    };
    this.inputEditRef = React.createRef();
    this.check = 0;
  }

  showActionEditDelete = () => {
    if (!this.props.isHover) {
      this.setState({ isShowActionEditDelete: true });
    }
  };

  hideActionEdit = () => {
    this.setState({ isShowActionEditDelete: false });
  };

  handleEdit = () => {
    const { user } = this.props;
    if (isNotLoginOrExpired(user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    this.check = 1;
    this.setState({ isShowConfirmEdit: true });
    this.props.toggleHover(true);
  };

  handleDelete = () => {
    const { user } = this.props;
    if (isNotLoginOrExpired(user)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }
    this.check = 1;
    this.setState({ isShowConfirmDelete: true });
    this.props.toggleHover(true);
  };

  handleChange = () => {
    const { currentKey, value, change } = this.props;

    const check = this.check;
    if (check !== 1) {
      this.check = 0;
      change(value, currentKey);
      this.resetState();
    } else {
      this.inputEditRef.current && this.inputEditRef.current.focus();
    }
  };

  acceptChange = key => {
    this.check = 1;
    this.resetState();
    const name = this.inputEditRef.current.value.trim();
    this.props.update(key, name);
  };

  acceptDelete = key => {
    this.check = 1;
    this.resetState();
    this.props.deleteAction(key);
  };

  cancel = () => {
    this.resetState();
  };

  resetState = () => {
    this.setState({
      isShowActionEditDelete: false,
      isShowConfirmEdit: false,
      isShowConfirmDelete: false,
    });
    this.props.resetDropDown(false, false);
  };

  changeInputText = (key, value) => {
    this.props.changeInputText(key, value);
  };

  isShowTooltip = () => {
    const { listDataByKey, keyShowTooltip, keyTitle, value } = this.props;

    return (
      listDataByKey[value] &&
      listDataByKey[value][keyTitle] &&
      keyShowTooltip[listDataByKey[value][keyTitle]]
    );
  };

  getTooltip = optionText => {
    const { tooltipText } = this.props;

    return tooltipText
      ? this.isShowTooltip() && I18n.t(tooltipText)
      : optionText;
  };

  render() {
    const {
      value,
      listDataByKey,
      isEditable,
      change,
      currentKey,
      toggleDropDown,
      keyTitle,
      isI18n,
      canNotDelete,
    } = this.props;

    const {
      isShowActionEditDelete,
      isShowConfirmEdit,
      isShowConfirmDelete,
    } = this.state;

    const optionText = isI18n
      ? I18n.t(listDataByKey[value][keyTitle])
      : listDataByKey[value][keyTitle];
    let content = optionText;
    if (isShowActionEditDelete && !canNotDelete) {
      content = (
        <>
          <span className="btn-edit">
            <span onMouseUp={this.handleEdit}>
              <i className="icon-pencil-edit" />
            </span>
            <span onMouseUp={this.handleDelete}>
              <i className="icon-bin-delete" />
            </span>
          </span>
          <div style={{ width: 50 }} className="text-truncate">
            {optionText}
          </div>
        </>
      );
    }

    if (isShowConfirmEdit) {
      content = (
        <form onSubmit={() => this.acceptChange(value)}>
          <input
            className="text-input"
            autoFocus
            type="text"
            style={{ width: 50 }}
            onChange={e => this.changeInputText(value, e.target.value)}
            ref={this.inputEditRef}
            defaultValue={optionText}
          />
          <span className="btn-edit">
            <span
              className="text-s-color-5 fs-16"
              onClick={() => this.acceptChange(value)}
            >
              <i className="icon-correct" />
            </span>
            <span className="text-s-color-3 fs-13" onClick={this.cancel}>
              <i className="icon-remove-symbol" />
            </span>
          </span>
        </form>
      );
    }

    if (isShowConfirmDelete) {
      content = (
        <>
          <div className="text-l-color-2 text-truncate" style={{ width: 50 }}>
            <span title={I18n.t('watchListSummary.confirmDelete')}>
              {I18n.t('watchListSummary.confirmDelete')}
            </span>
          </div>
          <span className="btn-edit">
            <span
              className="text-s-color-5 fs-16"
              onClick={() => this.acceptDelete(value)}
            >
              <i className="icon-correct" />
            </span>
            <span className="text-s-color-3 fs-13" onClick={this.cancel}>
              <i className="icon-remove-symbol" />
            </span>
          </span>
        </>
      );
    }

    return isEditable ? (
      <a
        title={this.getTooltip(optionText)}
        className="dropdown-item"
        href="#"
        onMouseUp={this.handleChange}
        onMouseLeave={this.hideActionEdit}
        onMouseEnter={this.showActionEditDelete}
      >
        {content}
      </a>
    ) : (
      <a
        title={this.getTooltip(optionText)}
        className="dropdown-item"
        href="#"
        onMouseUp={() => {
          change(value, currentKey);
          toggleDropDown(false);
        }}
      >
        {optionText}
      </a>
    );
  }
}

const mapStateToProps = state => ({ user: state.userInfo });

export default connect(mapStateToProps)(DropDownItem);
